<template>
  <tbody class="row_item">
    <tr>
      <td style="width: 40px; text-align: center" class="border-bottom">
        <CheckBox
          class="custom-checkbox-selector"
          @input="(state) => onSelectItem(item, state)"
          :readonly="disabled"
          v-model="selected"
          ref="check"
        />
      </td>

      <td
        v-for="(column, index) in internalColumns"
        :key="index"
        class="border-bottom"
        v-bind:style="{
          width:
            widthLastRows && index !== 0
              ? typeof widthLastRows === 'number'
                ? widthLastRows + 13 + 'px'
                : widthLastRows
              : 'auto',
        }"
      >
        <div @click.stop="toggleDetail()" v-if="item.children && index === 0">
          <span
            class="mdi mdi-chevron-down chevron-cell"
            :class="{ 'is-expanded': visibleDetailRow }"
            v-bind:style="{ marginLeft: -2 + 20 * (level - 1) + 'px' }"
          />
        </div>
        <span
          v-html="getData(item, column)"
          v-bind:style="{ marginLeft: (index === 0 ? 20 * level : 0) + 'px' }"
        />
      </td>
    </tr>

    <template v-if="visibleDetailRow">
      <tr>
        <td :colspan="4">
          <table class="detail-table" v-for="(item, index) in item.children" :key="index">
            <GridSelectorItem
              :item="item"
              :columns="internalColumns"
              :level="level + 1"
              :widthLastRows="widthLastRows"
              :selector="selector.children[index]"
              :expand="expand"
              @checkItem="checkParent()"
              @uncheckItem="uncheckParent()"
              ref="selectorItem"
            />
          </table>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import moment from 'moment';
import numbro from 'numbro';
import CheckBox from './CheckBox.vue';

export default {
  name: 'GridSelectorItem',
  components: { CheckBox },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    level: {
      type: Number,
      default: 1,
    },
    widthLastRows: {
      type: [Number, String],
      default: null,
    },
    selector: {
      type: Object,
      default: () => {},
    },
    expand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentItem: this.item || {},
      internalColumns: this.columns || [],
      visibleDetailRow: true,
      selected: this.selector.selected,
      disabled: this.selector.disabled,
      selectorsControl: this.selector.children || [],
      assigned: 0,
    };
  },
  mounted() {
    if (this.selector.partial) {
      this.setPartialCheck(true);
    }
    this.updateChecks(this.$refs);
    this.$emit('assigned', this.assigned);
  },
  methods: {
    onSelectItem(item, state) {
      this.selector.selected = state;
      this.setChildren(this.$refs, state);
      this.setSelectors(this.selectorsControl, state);

      if (state) {
        this.$emit('checkItem');
      } else {
        this.selector.partial = false;
        this.$emit('uncheckItem');
      }
    },
    setChildren(ref, selected) {
      if (ref.selectorItem)
        ref.selectorItem.forEach((item) => {
          if (!item.disabled) {
            item.selected = selected;
            item.setPartialCheck(false);
            this.setChildren(item.$refs, selected);
          }
        });
      else if (ref.item && !ref.disabled) {
        ref.selected = selected;
        ref.setPartialCheck(false);
        this.setChildren(ref.$refs, selected);
      }
    },
    setSelectors(selectors, selected) {
      if (Array.isArray(selectors)) {
        selectors.forEach((selector) => {
          if (!selector.disabled) {
            selector.selected = selected;
            selector.partial = false;
            if (selector.children) this.setSelectors(selector.children, selected);
          }
        });
      } else {
        const selector = selectors;
        if (!selector.disabled) {
          selector.selected = selected;
          selector.partial = false;
          if (selector.children) this.setSelectors(selector.children, selected);
        }
      }
    },
    setDependent(check) {
      const children = this.selectorsControl;

      children.forEach((child) => {
        if (child.dependentOn) {
          children.forEach((nodeChild, index) => {
            if (nodeChild !== child) {
              if (check) {
                if (child.dependentOn.some((id) => id === nodeChild.id) && nodeChild.selected) {
                  this.$refs.selectorItem.forEach((item) => {
                    if (item.selector === child) {
                      child.selected = true;
                      item.selected = true;
                      this.checkParent(false);
                    }
                  });
                }
              } else if (!child.selected) {
                const item = this.$refs.selectorItem[index];
                if (child.dependentOn.some((id) => id === item.selector.id)) {
                  // nodeChild.selected = false;
                  // item.selected = false;

                  this.setChildren(item, false);
                  this.setSelectors(nodeChild, false);
                  this.uncheckParent(false);
                }
              }
            }
          });
        }
      });
    },
    updateChecks(ref) {
      if (ref.selectorItem)
        ref.selectorItem.forEach((item) => {
          if (!item.item.children) {
            if (item.selected) {
              this.assigned += 1;
              item.$emit('checkItem');
            }
            this.visibleDetailRow = this.expand;
          }
          this.updateChecks(item.$refs);
        });
    },
    checkParent(setDependent = true) {
      this.selector.selected = true;
      this.selected = true;

      const checkedAll = this.selector.children.every((child) => child.selected || child.disabled);
      this.setPartialCheck(!checkedAll);
      this.selector.partial = !checkedAll;

      if (checkedAll) {
        const partialChecked = this.selector.children.some((child) => child.partial);
        this.setPartialCheck(partialChecked);
        this.selector.partial = partialChecked;
      }
      if (setDependent) this.setDependent(true);
      this.$emit('checkItem');
    },
    uncheckParent(setDependent = true) {
      const uncheckedAll = this.selector.children.every((child) => !child.selected);

      this.selector.selected = !uncheckedAll;
      this.selected = !uncheckedAll;

      this.setPartialCheck(!uncheckedAll);
      this.selector.partial = !uncheckedAll;

      if (setDependent) this.setDependent(false);
      this.$emit('uncheckItem');
    },
    getData(item, column) {
      const field = item[column.field];

      if (column.format) {
        if (column.format === 'd') {
          return moment(field).format('DD/MM/YYYY');
        }
        if (column.format.includes('c')) {
          const zeros = column.format.replace('c', '');
          return numbro(field).formatCurrency({
            mantissa: Number(zeros || 0),
            thousandSeparated: true,
          });
        }
      }

      if (column.template) {
        if (typeof column.template === 'function') {
          return column.template.apply(null, [item]);
        }
      }

      return field;
    },
    toggleDetail() {
      this.visibleDetailRow = !this.visibleDetailRow;
    },
    setPartialCheck(value) {
      this.$refs.check.setPartialCheck(value);
    },
  },
  watch: {
    columns(val) {
      this.internalColumns = val;
    },
  },
};
</script>

<style lang="scss">
.custom-checkbox-selector {
  display: inline;
  .pw-inputcheck {
    padding: 0;
    margin: 0;
    margin: 0;
  }
}

.row_item {
  /*border-bottom: 5px solid #d8e3eb;*/
  td {
    color: #333333;
    font-size: 16px;
    line-height: 34px;
    background-color: #fff;
  }
  .chevron-cell {
    float: left;
    position: absolute;
    font-size: 18px;

    &.is-expanded {
      transform: rotate(180deg);
      .mdi {
        margin-left: -4px;
        margin-top: 22px;
      }
    }
  }
}
.border-bottom {
  border-bottom: 1px solid #d8e3eb;
}

.detail-table {
  width: 100%;
  text-align: left;
  border-spacing: 0;
  table-layout: fixed;
  border-collapse: separate;
  padding: 0;
}
</style>
